import {EntityDomainModel} from "../../../infrastructure/models/entity/entity.domain-model";
import {CompetitionDomainModel} from "../../../domain/common/competition/models/competition-domain-model";

export class CompetitionsSliderTopDomainModel extends CompetitionDomainModel {
  apiModel: EntityDomainModel;

  constructor(apiModel) {
    super(apiModel, {}, {});

    this.sortIndex = apiModel.sortIndex;
  }
}
